import type { ExecutionEventsFormValues } from '../../typings'

import { useField } from 'react-final-form'

import { Block, Label, ReadonlyLabel, RestoreFieldButton } from '@/forms-legacy'
import { isDeepEqual } from '@/server-data'

import { useTexts } from './useTexts'
import { DynamicLoads } from './DynamicLoads'

const testId = 'dynamic-loads-field'

function identity(a: ExecutionEventsFormValues['dynamicLoads']) {
  return a
}

const fieldConfig = { parse: identity, isEqual: isDeepEqual }

export function DynamicLoadsField() {
  const formProps = useField('dynamicLoads', fieldConfig)
  const texts = useTexts()

  const {
    input: { value, onChange },
    meta: { error, dirty, initial },
  } = formProps

  const handleOnChange = (key: string, loadValue: number) => {
    onChange({ ...value, [key]: { ...value?.[key], value: loadValue } })
  }

  return (
    <Block error={!!error} dirty={!!dirty} data-testid={testId}>
      <Label>
        <ReadonlyLabel style={{ paddingLeft: 0 }} primary>
          {texts.title}
        </ReadonlyLabel>

        <RestoreFieldButton
          dirty={dirty}
          initial={initial}
          onChange={onChange}
          style={{ marginLeft: 12 }}
        />
      </Label>
      <DynamicLoads onChange={handleOnChange} value={value} error={error} />
    </Block>
  )
}
